/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unknown-property */
import React from 'react';
import Slick from 'react-slick';
import s from './WeatherHourlyForecast.scss';
import { IMAGE_URL } from '../../../constants';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';
import Morebtn from '../../../components_v2/desktop/Morebtn';

const ga4Call = () => {
  analyticsWrapper('ga4', {
    event: 'user_click',
    type: 'hourly_forecast_arrow',
    category: 'hourly_forecast_arrow_click',
    msid: '',
  });
};

const NextArrow = props => {
  const { className, onClick } = props;
  const handleClick = e => {
    ga4Call();
    if (onClick) onClick(e);
  };

  return (
    <span {...props} className={`btn next ${className}`} onClick={handleClick}>
      <i />
    </span>
  );
};

const PrevArrow = props => {
  const { className, onClick } = props;

  const handleClick = e => {
    ga4Call();
    if (onClick) onClick(e);
  };

  return (
    <span {...props} className={`btn prev ${className}`} onClick={handleClick}>
      <i />
    </span>
  );
};

const settings = {
  dots: false,
  slidesToShow: 5,
  slidesToScroll: 5,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  infinite: false,
  responsive: [
    {
      breakpoint: 1510,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 4.6,
      },
    },
  ],
};

const WeatherHourlyForecast = ({
  hourlyData,
  weatherForcastPageUrl,
  cityName,
}) => (
  <div className={s.weatherHourlyWrapper}>
    {weatherForcastPageUrl && (
      <div className={s.weatherViewAction}>
        <div className={s.noblurBg} boxWrap />
        <div className={s.actnBlock}>
          <div>Check complete weather forecast of {cityName}</div>
          <Morebtn
            moreLink={weatherForcastPageUrl}
            moreText="View Weather Forecast"
            redBrdr
            fullWidth
            ga4Data={[
              {
                event: 'user_click',
                type: 'view_forecast_click',
                category: `${cityName}_view_weather_click`,
                label: 'weather_aqi_landing',
              },
            ]}
          />
        </div>
      </div>
    )}
    <div className={`${s.weatherHourlyForecast} boxWrap`}>
      <div className="fs12 hFont mb12 flex flexAc">
        <i className={`icon mr6 ${hourlyData?.icon}`} />
        {hourlyData?.name}
      </div>
      <div className={`${s.hourlyForcastList} slick_UI smallArrow`}>
        <Slick {...settings}>
          {hourlyData?.items &&
            Array.isArray(hourlyData.items) &&
            hourlyData.items.length > 0 &&
            hourlyData.items.map(item => (
              <div className="fs12">
                <div>{item?.time}</div>
                <img
                  className="mtb12"
                  src={`${IMAGE_URL}${item?.icon}.cms`}
                  alt={item?.icon}
                />
                <div className="bold">
                  {item?.value}
                  {item?.unit}
                </div>
              </div>
            ))}
        </Slick>
      </div>
    </div>
  </div>
);

export default WeatherHourlyForecast;
